import {FullGameFetchHandler} from "../../../../../core/handlers/full-game.fetch-handler";

export class GameInfoModuleFetchHandler extends FullGameFetchHandler {}
